import React, { memo } from 'react'
import tw from 'twin.macro'
import { Chip } from 'src/components/shared/Chip'
import { ExpirationIndicator } from 'src/interfaces/contractor'
import { colors } from 'src/theme'

interface Props {
  expiresInDays?: number | null
  expirationIndicator?: ExpirationIndicator | null
  label?: string
}

const getChipProps = (
  expirationIndicator: ExpirationIndicator | null | undefined,
  expiresInDays: number | null | undefined,
  label?: string,
) => {
  if (expirationIndicator === ExpirationIndicator.Expired) {
    return {
      text: label ?? 'Expired',
      textColor: colors.COLORS_RED_500,
      bgStyle: tw`bg-[rgba(255,220,220,1)]`,
    }
  }

  if (expirationIndicator === ExpirationIndicator.ExpiringSoon) {
    const defaultLabel = expiresInDays != null ? `${expiresInDays} days` : 'Expiring soon'

    return {
      text: label ?? defaultLabel,
      textColor: colors.COLORS_ORANGE_500,
      bgStyle: tw`bg-[rgba(255,238,214,1)]`,
    }
  }

  if (expirationIndicator === ExpirationIndicator.Valid) {
    const defaultLabel = expiresInDays != null ? `${expiresInDays} days` : '-'

    return {
      text: label ?? defaultLabel,
      textColor: colors.COLORS_GREEN_500,
      bgStyle: tw`bg-[rgba(230,249,233,1)]`,
    }
  }

  return null
}

const ExpirationIndicatorChipComponent = ({ expiresInDays, expirationIndicator, label }: Props) => {
  const chipProps = getChipProps(expirationIndicator, expiresInDays, label)

  if (!chipProps) {
    return <span>-</span>
  }

  return (
    <Chip text={chipProps.text} textColor={chipProps.textColor} className={chipProps.bgStyle} />
  )
}

export const ExpirationIndicatorChip = memo(ExpirationIndicatorChipComponent)
